module.exports = __webpack_public_path__ + "static/media/Banner-lineas-de-atencion.d6d887be.jpg";